// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"fa99c400","656":"55917459","751":"2f955bb0","780":"a30ba2ec","822":"f152254c","831":"44bb846c","906":"2ff76afa","972":"c70a2e66"}[chunkId] + ".chunk.js";
};